<template>
  <div class="page login-page">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title" v-if="fromPartnerChannel">{{partner.name}}</h2>
        <h2 class="weui-form__title">
          <span v-if="fromPartnerChannel">诚邀您使用</span><span v-else>开通</span>云系统
        </h2>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">企业：</label>
              </div>
              <div class="weui-cell__bd">
                {{ signInfo.companyName }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">姓名：</label>
              </div>
              <div class="weui-cell__bd">
                {{ signInfo.userName }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">手机号码：</label>
              </div>
              <div class="weui-cell__bd">
                {{ signInfo.mobile }}
              </div>
            </div>
            <div class="weui-cell weui-cell_active weui-cell_vcode">
              <div class="weui-cell__bd">
                <input
                  v-model="signInfo.validCode"
                  class="weui-input"
                  placeholder="请输入验证码"
                />
              </div>
              <div class="weui-cell__ft" @click="getValidCode">
                <button
                  class="weui-btn weui-btn_default weui-vcode-btn"
                  :class="{ 'weui-btn_disabled': isLocked }"
                >
                  <span v-if="!waitTime">获取验证码</span
                  ><span v-else>{{ waitTime }}秒后再试</span>
                </button>
              </div>
            </div>
            <div v-if="signInfo.inviteCode" class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">专属顾问：</label>
              </div>
              <div class="weui-cell__bd">
                {{ adviser.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells__title">选择解决方案</div>
          <div class="weui-cells weui-cells_radio">
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x11"
            >
              <div class="weui-cell__bd">
                <p>贸易云</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  class="weui-check"
                  v-model="signInfo.appId"
                  value="trade-app"
                  checked="checked"
                  id="x11"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
            <label
              class="weui-cell weui-cell_active weui-check__label"
              for="x12"
            >
              <div class="weui-cell__bd">
                <p>制造云</p>
              </div>
              <div class="weui-cell__ft">
                <input
                  type="radio"
                  v-model="signInfo.appId"
                  value="make-app"
                  class="weui-check"
                  id="x12"
                />
                <span class="weui-icon-checked"></span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area opr-block">
        <a
          class="weui-btn weui-btn__auto weui-btn_primary"
          :class="{ 'weui-btn_disabled': !isValidForm }"
          @click="register"
          >立即开通</a
        >
      </div>
      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__links">
            <a v-if="companies" class="weui-footer__link" @click="selectCompany"
              >选择其它企业</a
            >
            <a class="weui-footer__link" @click="registerNew">注册新企业</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from "@/util/validator.js";
import wait from "@/mixins/wait.js";
import captcha from "@/mixins/captcha.js";
import Auth from "@/util/auth.js";
import Session from "@/util/session";

export default {
  mixins: [wait, captcha],
  data() {
    return {
      signInfo: {
        companyName: null,
        businessCode: null,
        userName: null,
        mobile: null,
        validCode: null,
        appId: "trade-app",
        inviteCode: null,
      },
      adviser: {
        name: ''
      },
      partner: {
        name: ''
      },
      partnerUser: null,
      companies: [],
    };
  },
  computed: {
    isMobileValid() {
      return Validator.isMobile(this.signInfo.mobile);
    },
    isLocked() {
      const me = this;
      return !me.isMobileValid || me.isWaiting;
    },
    isValidForm() {
      const me = this,
        signInfo = me.signInfo;
      return (
        me.isMobileValid &&
        signInfo.companyName &&
        signInfo.userName &&
        signInfo.validCode
      );
    },
    /**
     * 来自合作伙伴渠道
     */
    fromPartnerChannel() {
      return this.partner && this.partner.name;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.companies = to.params.companies;
      let signInfo = to.params.signInfo,
        inviteCode = to.params.inviteCode,
        partnerUU = to.params.partner;
      if (signInfo) {
        vm.signInfo = Object.assign(signInfo, { appId: "trade-app", inviteCode: null });
      }
      if (inviteCode) {
        vm.getAdviserInfo(inviteCode);
      }
      if (partnerUU) {
        vm.getPartnerInfo(partnerUU);
        vm.partnerUser = to.params.partnerUser;
      }
    });
  },
  methods: {
    /**
     * 获取验证码
     */
    getValidCode() {
      const me = this;
      if (me.isLocked) {
        return;
      }
      me.$captcha.show();
      me.$bus.$on('getTicket', res => {
        if (res.ret === 0) {
          me.addWaitTask();
          me.$loading({
            url: "/api/account/company/register/vcode",
            method: "POST",
            params: {
              mobile: me.signInfo.mobile,
              ticket: res.ticket,
              appId: res.appid,
              randstr: res.randstr
            },
          }).then(function (res) {
            if (res.success) {
              me.$weui.toast("发送成功", 2000);
            } else {
              me.$weui.topTips("发送失败", 3000);
              me.clearWaitTask();
            }
          });
        } else {
          me.$weui.topTips('未通过验证');
        }
        me.$bus.$off('getTicket')
      })
    },
    /**
     * 注册
     */
    register() {
      const me = this;
      if (!me.isValidForm) {
        return;
      }
      var data = Object.assign({}, me.signInfo);
      if (me.fromPartnerChannel) {
        // 合作伙伴同时成为顾问
        data.inviteCode = me.partner.enuu + '-' + (me.partnerUser || 0);
      }
      me.$loading({
        url: "/api/account/company/register/v2",
        method: "POST",
        jsonData: data,
      }).then(function (res) {
        if (res.success) {
          let authData = res.data;
          Auth.set(authData);
          if (me.fromPartnerChannel) {
            me.$router.push({
              name: "ApplyPartner",
              params: { partner: me.partner, authData, partnerUser: me.partnerUser }
            });
          } else {
            me.$router.push("/" + authData.appId.replace("-app", ""));
          }
        } else {
          me.$weui.topTips("开通失败：" + res.message, 3000);
        }
      });
    },
    /**
     * 顾问信息
     */
    getAdviserInfo(inviteCode) {
      const me = this;
      me.$ajax({
        url: "/api/account/partner/read",
        params: {
          inviteCode,
        },
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data && data.name) {
            me.signInfo.inviteCode = inviteCode;
            me.adviser = data;
          }
        }
      });
    },
    /**
     * 选择其它企业
     */
    selectCompany() {
      const me = this;
      let items = me.companies.map((c) => {
        return {
          label: c.name,
          value: c,
        };
      });
      me.$weui.picker(items, {
        title: "选择企业",
        onConfirm: function (result) {
          let company = result[0].value;
          if (company.id) {
            // 已开通云系统
            me.switchCompany(company.id);
          } else {
            // 未开通
            me.signInfo.companyName = company.name;
          }
        },
      });
    },
    /**
     * 切换账套
     */
    switchCompany(companyId) {
      const me = this,
        token = Session.getToken(),
        headers = token ? {
          Authorization: token
        } : {};
      me.$loading({
        url: "/api/auth/switch/company",
        method: "POST",
        headers,
        params: {
          companyId,
        },
        withCredentials: true,
      }).then(function (res) {
        if (res.success) {
          let token = res.data,
            authData = Session.get(),
            account = authData.account,
            company = account.companies.find(
              (item) => item.id == companyId
            ),
            appId = company.app;
          account.defaultCompany = company;
          account.companyId = companyId;
          authData = Auth.set({
            token,
            appId,
            account,
          });
          // 来自合伙人邀请
          if (me.signInfo.inviteCode) {
            me.checkAdviserStatus(me.signInfo.inviteCode, authData);
          } else if (me.fromPartnerChannel && me.partner.enuu != company.uu) {
            // 来自合作伙伴二维码邀请
            me.$router.push({
              name: "ApplyPartner",
              params: { partner: me.partner, authData, partnerUser: me.partnerUser }
            });
          } else {
            me.redirectApp(authData);
          }
        } else {
          me.$weui.topTips("切换失败：" + res.message, 3000);
        }
      });
    },
    /**
     * 跳转注册新企业
     */
    registerNew() {
      const me = this;
      me.$router.push({
        name: "Register",
        params: {
          signInfo: {
            mobile: me.signInfo.mobile,
            userName: me.signInfo.userName,
            appId: me.signInfo.appId,
          },
          inviteCode: me.signInfo.inviteCode,
          partner: me.partner ? me.partner.enuu : null,
          partnerUser: me.partnerUser
        },
      });
    },
    /**
     * 检查绑定顾问的状态
     */
    checkAdviserStatus(inviteCode, authData) {
      const me = this;
      me.$ajax({
        url: "/api/account/partner/customer/status",
        params: {
          inviteCode,
        },
      }).then(function (res) {
        if (res.success) {
          let data = res.data;
          if (data.hasPartner) {
            let partner = data.customer.partner;
            me.$weui.alert(
              `您的企业(${authData.account.defaultCompany.name})已经绑定了顾问 ${partner.name}`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "知道了",
                    type: "primary",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                ],
              }
            );
          } else if (data.inviter) {
            me.$weui.confirm(
              `${data.inviter.name} 将成为您企业(${authData.account.defaultCompany.name})的专属顾问`,
              {
                title: "提示",
                buttons: [
                  {
                    label: "不同意",
                    type: "default",
                    onClick: function () {
                      me.redirectApp(authData);
                    },
                  },
                  {
                    label: "同意",
                    type: "primary",
                    onClick: function () {
                      me.bindAdviser(inviteCode, authData);
                    },
                  },
                ],
              }
            );
          } else {
            me.redirectApp(authData);
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function () {
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    redirectApp(authData) {
      this.$router.push("/" + authData.appId.replace("-app", ""));
    },
    /**
     * 绑定顾问
     */
    bindAdviser(inviteCode, authData) {
      const me = this;
      me.$loading({
        url: "/api/account/partner/customer/open",
        method: "post",
        params: {
          inviteCode,
        },
      }).then(function (res) {
        if (res.success) {
          let data = res.data;
          if (!data.hasPartner) {
            me.$weui.alert(`绑定顾问失败`, {
              title: "出错了",
              buttons: [
                {
                  label: "知道了",
                  type: "primary",
                  onClick: function () {
                    me.redirectApp(authData);
                  },
                },
              ],
            });
          } else {
            me.$weui.alert(`${data.inviter.name} 是您的专属顾问了`, {
              title: "提示",
              buttons: [
                {
                  label: "知道了",
                  type: "primary",
                  onClick: function () {
                    me.redirectApp(authData);
                  },
                },
              ],
            });
          }
        } else {
          me.$weui.topTips(res.message, 3000);
          setTimeout(function () {
            me.redirectApp(authData);
          }, 3000);
        }
      });
    },
    /**
     * 合作伙伴信息
     */
    getPartnerInfo(uu) {
      const me = this;
      me.$ajax({
        url: "/api/account/company/sso_info",
        params: {
          uu
        },
      }).then(function (res) {
        if (res.success) {
          var data = res.data;
          if (data && data.name) {
            me.partner = data;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.opr-block {
  padding: 0 32px;
}
</style>

